// project imports
import * as actionTypes from "./actions";

export const initialState = {
  charts: [],
};

const returnChartReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CHART:
      return {
        ...state,
        charts: action.value,
      };
    default:
      return state;
  }
};

export default returnChartReducer;
